import { SsoAccountData, AgreementLoanState, AgreementForLoanMeta, AgreementSigningStatus } from "../../core/data/sso-account/domain/models/sso-account.model";
import { ProductCode, ProductCodeLabel } from "../product/product.model";
import { NeedsAttentionInput } from "../needs-attention/needs-attention.model";
import { NeedsAttentionHelper } from "../needs-attention/needs-attention.helper";
import { LoanData } from "./loan.model";

export class LoanHelper {
  static isLoanPendingForSign(loanId: number, currentAccount: SsoAccountData): boolean {
    const loanState = this.findLoan(loanId, currentAccount);
    return loanState?.agreementState?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser;
  }

  static isLoanPendingForSignByOthers(loanId: number, currentAccount: SsoAccountData): boolean {
    const loanState = this.findLoan(loanId, currentAccount);
    return loanState?.agreementState?.agreementSigningStatus === AgreementSigningStatus.PendingOthers;
  }

  static getLoanAgreementState(loanId: number, currentAccount: SsoAccountData): AgreementLoanState | undefined {
    const loanState = this.findLoan(loanId, currentAccount);
    return loanState?.agreementState;
  }

  static getLoanWithAgreementState(loanId: number, currentAccount: SsoAccountData): AgreementForLoanMeta {
    return this.findLoan(loanId, currentAccount);
  }

  private static findLoan(loanId: number, currentAccount: SsoAccountData): AgreementForLoanMeta {
    return currentAccount?.loans?.find(l => l.loanId === loanId);
  }

  static getOutstandingBalance(loan: LoanData): number {
    if (loan.productCode === ProductCode.Term)
      return loan.loanInfo?.principalBalance + loan.loanInfo?.accruedInterest;
    else 
      return loan.loanInfo?.principalBalance;
  }

  static getNeedsAttentionMessage(loan: LoanData): string {
    return NeedsAttentionHelper.getNeedsAttentionMessage(this.getNeedsAttentionMessageInput(loan));
  }

  static getNeedsAttentionMessageInput(loan: LoanData): NeedsAttentionInput {
    return {
      firstName: loan?.advisorFirstName,
      lastName: loan?.advisorLastName,
      email: loan?.advisorEmail,
      phone: loan?.advisorPhone,
      productName: ProductCodeLabel.get(loan?.productCode)
    };
  }
}
